module.exports = __webpack_public_path__ + "static/media/play-video.2696ae7f.svg";